import resize from './src/resize.js'

var resizeDirective = {};
resizeDirective.install = function(Vue){
  Vue.directive(resize.directiveName, resize);
}

export default resizeDirective;



// WEBPACK FOOTER //
// ./src/directives/resize/index.js